export default "<div class=\"slide\" [hidden]=\"!active\">\n  <ng-content></ng-content>\n</div>\n"